import Vue from 'vue';
import feathersClient from '../../feathers-client';

const defaultJobTemplatePagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultJobTemplateFilter = {
	$skip: defaultJobTemplatePagination.$skip,
	$limit: defaultJobTemplatePagination.$limit,
};

export default {
	namespaced: true,
	state: {
		jobTemplates: [],
		jobTemplateFilter: defaultJobTemplateFilter,
		jobTemplatePagination: defaultJobTemplatePagination,
		trusts: [],
	},
	getters: {
		jobTemplatePage: (state) => {
			const { $limit, $skip } = state.jobTemplatePagination;
			return $skip / $limit + 1;
		},
		jobTemplates: (state) => state.jobTemplates,
	},
	mutations: {
		SET_JOB_TEMPLATES: (state, jobTemplates) => { state.jobTemplates = jobTemplates; },
		SET_JOB_TEMPLATE_FILTER: (state, filter) => { state.jobTemplateFilter = { ...state.jobTemplateFilter, ...filter }; },
		SET_DEFAULT_JOB_TEMPLATE_FILTER: (state, filter) => { state.jobTemplateFilter = { ...filter, ...defaultJobTemplateFilter }; },
		SET_JOB_TEMPLATE_PAGINATION: (state, data) => { state.jobTemplatePagination = { ...state.jobTemplatePagination, ...data }; },
		SET_TRUSTS: (state, trusts) => { state.trusts = trusts; },
	},
	actions: {
		setJobTemplateFilter: ({ commit }, filter) => {
			commit('SET_JOB_TEMPLATE_FILTER', filter);
		},
		setDefaultJobTemplateFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_JOB_TEMPLATE_FILTER', filter);
		},
		setJobTemplatePage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.jobTemplatePagination.$limit;
			commit('SET_JOB_TEMPLATE_PAGINATION', { $skip });
			commit('SET_JOB_TEMPLATE_FILTER', { $skip });
		},
		selectedPersonaSkills: async ({ rootGetters }, filter) => {
			const url = '/api/v3/getstaffpersonaskills';
			const results = await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole,
					...filter,
				},
			});
			return results;
		},
		getSkillsForJobTemplate: async ({ rootGetters }, filter) => {
			const url = '/api/v3/skills';
			const results = await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole,
					status: 'Active',
					$paginate: false,
				},
			});
			return results;
		},
		addJobTemplate: async ({ rootGetters }, data) => {
			const url = '/api/v3/jobtemplates';
			const result = await feathersClient.service(url).create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return result;
		},
		updateJobTemplate: async ({ rootGetters }, jobTemplate) => {
			const id = jobTemplate.id;
			delete jobTemplate.id;
			const url = '/api/v3/jobtemplates';
			const result = await feathersClient.service(url).patch(id, jobTemplate, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return result;
		},
		deleteJobTemplateSkills: async ({ rootGetters }, data) => {
			const url = '/api/v3/jobtemplateskills';
			const results = await feathersClient.service(url).remove(null, {
				query: {
					$role: rootGetters.currentUserRole,
					...data,
				},
			});
			return results;
		},
		searchPersonasForJobTemplate: async ({ rootGetters }, filter) => {
			const url = '/api/v3/staffpersonas';
			const results = await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole,
					$paginate: false,
				},
			});
			return results;
		},
		loadJobSkillTemplates: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/jobtemplates';
			const results = await feathersClient.service(url).find({
				query: {
					fields: [ 'owner', 'baseStaffPersona'],
					$role: rootGetters.currentUserRole,
					...filter,
				},
			});
			commit('SET_JOB_TEMPLATES', results.data);
			commit('SET_JOB_TEMPLATE_PAGINATION', { total: results.total });
		},
		loadTrusts: async ({ commit }, filter) => {
			const url = '/api/v3/trusts';
			const results = await feathersClient.service(url).find({});
			commit('SET_TRUSTS', results.data);
		},
		deleteTemplates: async ({ rootGetters }, data) => {
			const url = '/api/v3/jobtemplates';
			const results = await feathersClient.service(url).remove(null, {
				query: {
					$role: rootGetters.currentUserRole,
					_id: data.templates,
				},
			});
			return results;
		},
	},
};
